import { authApiService } from '@/api/authApiService';
import { ApiResponseType } from '@/types/sharedTypes';
import { RecipientRequestType } from '@/types/vendorVaultTypes';

export type WireConfirmationPayloadType = {
  reference: string;
  amount: string;
  date: string | null;
  send_to: string;
  note?: string;
};

export const sendWireConfirmationApi = (
  id: string,
  data: WireConfirmationPayloadType
): Promise<ApiResponseType<RecipientRequestType>> =>
  authApiService.POST(`/vendor-vault/requests/${id}/wire-confirmation/`, data);
